var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2488 8.74575L11.1057 2.14825C11.0456 2.06388 10.9661 1.9951 10.8741 1.94764C10.782 1.90019 10.6799 1.87543 10.5763 1.87543C10.4727 1.87543 10.3706 1.90019 10.2785 1.94764C10.1864 1.9951 10.107 2.06388 10.0469 2.14825L5.88504 8.77763C5.30733 9.71028 4.98529 10.7786 4.95129 11.8751C4.95129 13.367 5.54393 14.7977 6.59882 15.8526C7.65371 16.9075 9.08445 17.5001 10.5763 17.5001C12.0681 17.5001 13.4989 16.9075 14.5538 15.8526C15.6087 14.7977 16.2013 13.367 16.2013 11.8751C16.1655 10.7662 15.8368 9.68657 15.2488 8.74575ZM10.5763 16.2501C9.41648 16.2485 8.30464 15.787 7.48453 14.9669C6.66441 14.1468 6.20295 13.0349 6.20129 11.8751C6.23515 11.0012 6.49764 10.1515 6.96254 9.41075L7.54692 8.4795L13.8432 14.7758C13.4342 15.239 12.9314 15.61 12.3682 15.8643C11.805 16.1186 11.1942 16.2497 10.5763 16.2501Z",
    fill: "#4FD1DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.a656c175e70e2f5dc62190e372c21bc6.svg";
export { ForwardRef as ReactComponent };